import {Injectable} from '@angular/core';
import {LocalStorageManager} from 'src/app/data/manager/local-storage/local-storage.manager';
import {countryConfig} from 'src/country-config/country-config';

@Injectable({
  providedIn: 'root',
})
export class ValidateStockAlgoliaUtil {
  constructor(private localStorageManager: LocalStorageManager) {}

  validateStockOfProducts(dataProducts) {
    const nearbyStores = this.localStorageManager.get('nearbyStores');

    if (nearbyStores?.length === 0) {
      return dataProducts;
    }

    dataProducts.map(product => {
      const hasStockProduct = product?.hasStock;
      if (hasStockProduct) {
        const quantityWhitoutStock = 0;
        const totalStock = product?.totalStock ?? countryConfig.temporalStock;
        product.totalStock = hasStockProduct ? totalStock : quantityWhitoutStock;
      }else if(!product?.totalStock){
        product.totalStock = 0; 
      }
      return product;
    });
    return dataProducts;
  }
}
